/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const challengeSchema = z.object({
  // Identity
  id: z.number(),
  slug: z.string(),
  type: z.string(),
  language: z.string(),

  // Head (display)
  title: z.string(),
  originalTitle: z.string().nullable().optional(),
  normalized: z.string(),
  variants: z.string().nullable(),

  // Pronunciation
  ipaUk: z.string().nullable(),
  ipaUs: z.string().nullable(),

  // Difficulty & frequency
  cefrLevel: z.string(),
  frequencyRank: z.number().nullable(),
  frequencyBand: z.string().nullable(),
  difficulty: z.number(),

  // Primary sense
  partOfSpeech: z.string(),
  definition: z.string(),
  definitionSimple: z.string().nullable(),
  register: z.string(),
  grammarPattern: z.string().nullable(),
  usageNotes: z.string().nullable(),

  // Examples (JSON array stored as TEXT)
  examples: z.string(),

  // Vocabulary network (JSON arrays stored as TEXT)
  collocations: z.string().nullable(),
  synonyms: z.string().nullable(),
  antonyms: z.string().nullable(),
  commonMistakes: z.string(),
  mnemonicHint: z.string().nullable(),

  // Flexible fields
  chunkType: z.string().nullable(),
  literalMeaning: z.string().nullable(),
  variableSlots: z.string().nullable(),
  regionalVariation: z.string().nullable(),

  // Additional senses (JSON stored as TEXT)
  additionalSenses: z.string().nullable(),

  // Word-specific
  wordFamily: z.string().nullable(),
  etymology: z.string().nullable(),

  // Collection flags
  ox3000: z.number(),
  ox5000: z.number(),
  academic: z.number(),

  // Media
  imageUrl: z.string().nullable(),
  imagePrompt: z.string().nullable(),
  titleAudioUrl: z.string().nullable(),
  definitionAudioUrl: z.string().nullable(),
  usageNotesAudioUrl: z.string().nullable(),

  // Quality & generation metadata
  generationModel: z.string().nullable(),
  generationPromptVersion: z.string().nullable(),
  generatedAt: z.string().nullable(),
  confidenceScore: z.number().nullable(),
  qualityScore: z.number().nullable(),
  suggestedForm: z.string().nullable(),
  qualityReasoning: z.string().nullable(),
  triageStatus: z.string(),
  published: z.number(),
  errorReports: z.number(),

  // List-only computed
  clipCount: z.number().optional(),

  // Timestamps
  createdAt: z.number(),
  updatedAt: z.number(),
  deletedAt: z.number().nullable(),
});

export type IChallenge = z.infer<typeof challengeSchema>;
